<template>
  <span>
    {{ percent | number('0.00') }}%
  </span>
</template>

<script>
import currency from 'currency.js';

export default {
  props: {
    totalizadores: Object,
    fornecedor: Object,
  },
  computed: {
    percent() {
      if (!this.totalizadores || !this.fornecedor) {
        return 0;
      }
      return this.percentCompras
        .add(this.percentItens)
        .divide(2);
    },
    percentCompras() {
      if (!this.totalizadores || !this.fornecedor) {
        return 0;
      }
      return currency(this.fornecedor.total)
        .multiply(100)
        .divide(currency(this.totalizadores.total));
    },
    percentItens() {
      if (!this.totalizadores || !this.fornecedor) {
        return 0;
      }
      return currency(this.fornecedor.quantidadeProdutos)
        .multiply(100)
        .divide(currency(this.totalizadores.quantidadeProdutos));
    },
  },
};
</script>
